import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-fill text-lg w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="font-heading text-lg font-black">日韩在线</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              汇集最新日韩电影与电视剧资讯，用简洁清晰的方式呈现剧集信息与热门推荐。
              本站为影视内容展示平台，所有播放功能均为前端演示，不提供真实播放接口。
            </p>
            <div className="mt-5 flex items-center gap-2 flex-wrap">
              <span className="px-2.5 py-1 rounded-md bg-background-50/10 text-xs font-label text-background-200">
                日韩影视
              </span>
              <span className="px-2.5 py-1 rounded-md bg-background-50/10 text-xs font-label text-background-200">
                每周更新
              </span>
              <span className="px-2.5 py-1 rounded-md bg-background-50/10 text-xs font-label text-background-200">
                纯前端演示
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-300 transition-colors">浏览导航</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200/80 hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/category/movie" className="text-background-200/80 hover:text-background-50 transition-colors">日本 / 韩国电影</Link></li>
              <li><Link to="/category/drama" className="text-background-200/80 hover:text-background-50 transition-colors">日韩电视剧</Link></li>
              <li><Link to="/search" className="text-background-200/80 hover:text-background-50 transition-colors">搜索影视</Link></li>
              <li><Link to="/favorites" className="text-background-200/80 hover:text-background-50 transition-colors">我的收藏</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              <Link to="/about" className="hover:text-accent-300 transition-colors">关于本站</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-background-200/80 hover:text-background-50 transition-colors">网站定位</Link></li>
              <li><Link to="/about" className="text-background-200/80 hover:text-background-50 transition-colors">内容范围</Link></li>
              <li><Link to="/about" className="text-background-200/80 hover:text-background-50 transition-colors">免责声明</Link></li>
              <li><Link to="/about" className="text-background-200/80 hover:text-background-50 transition-colors">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © 2026 日韩在线 JK Online. 本站内容为演示数据，仅供浏览参考。
          </p>
          <p className="text-xs text-background-200/60">
            友情提示：本站不提供任何影视资源的存储与下载服务。
          </p>
        </div>
      </div>
    </footer>
  );
}